var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 794,
    zoomAndPan: "magnify",
    viewBox: "0 0 595.5 842.249979",
    height: 1123,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8e7994a92b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.4375 0.492188 L 343 0.492188 L 343 326.578125 L 0.4375 326.578125 Z M 0.4375 0.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "14ba01ebc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 171.5 0.492188 L 211.882812 125.046875 L 342.5625 125.046875 L 236.839844 202.027344 L 277.222656 326.578125 L 171.5 249.601562 L 65.777344 326.578125 L 106.160156 202.027344 L 0.4375 125.046875 L 131.117188 125.046875 Z M 171.5 0.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3cd7eb1010"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.4375 0.492188 L 342.796875 0.492188 L 342.796875 326.578125 L 0.4375 326.578125 Z M 0.4375 0.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb347019d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 171.5 0.492188 L 211.882812 125.046875 L 342.5625 125.046875 L 236.839844 202.027344 L 277.222656 326.578125 L 171.5 249.601562 L 65.777344 326.578125 L 106.160156 202.027344 L 0.4375 125.046875 L 131.117188 125.046875 Z M 171.5 0.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "35c78d5f2e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 343,
    y: 0,
    height: 327
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8075a5315a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 344,
    y: 0,
    height: 327
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 126, 220)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8075a5315a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e7994a92b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#14ba01ebc2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.000000000000014211, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35c78d5f2e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3cd7eb1010)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb347019d5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#008000",
    d: "M 0.4375 0.492188 L 343.085938 0.492188 L 343.085938 326.578125 L 0.4375 326.578125 Z M 0.4375 0.492188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/greenStar.89e1857e0369ba805cc9b29bbde66678.svg";
export { ForwardRef as ReactComponent };